import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface PhoneFrameProps {
  children: ReactNode;
  className?: string;
}

export function PhoneFrame({ children, className }: PhoneFrameProps) {
  return (
    <div
      className={cn(
        "relative h-[748px] w-[360px] shrink-0 rounded-[48px] bg-gradient-to-b from-[#404040] to-[#171717] p-[6px] shadow-[0px_18px_50px_rgba(31,30,29,0.4)]",
        className,
      )}
    >
      <div className="h-full w-full rounded-[43px] bg-[#0a0a0a] p-[3px]">
        <div className="relative h-full w-full overflow-hidden rounded-[40px] bg-white">
          {children}
          <div className="pointer-events-none absolute left-1/2 top-2.5 z-20 h-[26px] w-[92px] -translate-x-1/2 rounded-full bg-black" />
        </div>
      </div>
    </div>
  );
}
